import { s4pApi } from "@/query/apiSlice";
import { store } from "@/store";

import { tagsFromNotificationData } from "./navigateFromNotificationData";

/**
 * Invalidates inbox (bell badge) and type-specific caches for an incoming push.
 */
export function refreshQueriesFromPush(
    data: Record<string, unknown> | undefined,
): void {
    store.dispatch(
        s4pApi.util.invalidateTags([
            "ParentMessages",
            ...tagsFromNotificationData(data),
        ]),
    );
}
